import * as React from 'react';

import { Props } from './types';
import { arePropsEqual } from './utils';

const FlatCloseIcon = React.memo(
  ({ className }: Props) => (
    <svg
        data-testid="flat-close-icon"
        className={className}
        fill="none"
        height="5"
        viewBox="0 0 36 5"
        width="36"
        xmlns="http://www.w3.org/2000/svg">
        <rect fill="#fff" height="5" rx="2.5" width="36"/>
    </svg>
  ),
  arePropsEqual
);

export default FlatCloseIcon;
